import React from 'react';
import { Link, Navigate, Outlet, useLocation } from 'react-router-dom';
import { useComprasPurchaseSite } from '../../contexts/ComprasPurchaseSiteContext';
import { useModuleSettings } from '../../contexts/ModuleSettingsContext';

const COMPRAS_GATED_PREFIXES = [
  '/purchase-orders',
  '/service-orders',
  '/requirements',
  '/documents',
  '/supply-continuous-documents',
  '/continuous-services',
];

export function isComprasSiteGatedPath(pathname) {
  return COMPRAS_GATED_PREFIXES.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`)
  );
}

const ComprasSiteBanner = () => {
  const { selectedPurchaseSite, isWithoutSiteMode } = useComprasPurchaseSite();
  const location = useLocation();
  if (!selectedPurchaseSite?.id && !isWithoutSiteMode) return null;

  return (
    <div
      className={`border-b px-6 py-2 flex flex-wrap items-center justify-between gap-2 text-sm ${
        isWithoutSiteMode
          ? 'bg-amber-50 border-amber-100'
          : 'bg-teal-50 border-teal-100'
      }`}
    >
      <span className={isWithoutSiteMode ? 'text-amber-900' : 'text-teal-900'}>
        {isWithoutSiteMode ? (
          <>
            Vista: <strong>Documentos sin sede</strong>
            <span className="text-amber-700 ml-2">(histórico pendiente de asignación)</span>
          </>
        ) : (
          <>
            Sede de compra:{' '}
            <strong>
              {selectedPurchaseSite.code ? `${selectedPurchaseSite.code} — ` : ''}
              {selectedPurchaseSite.name}
            </strong>
          </>
        )}
      </span>
      <Link
        to="/compras/select-site"
        state={{ from: location.pathname }}
        className="text-teal-700 hover:text-teal-900 font-medium underline-offset-2 hover:underline"
      >
        Cambiar sede
      </Link>
    </div>
  );
};

const ComprasPurchaseSiteGate = () => {
  const { comprasPurchaseSitesEnabled, loaded } = useModuleSettings();
  const { selectedPurchaseSite, isWithoutSiteMode } = useComprasPurchaseSite();
  const location = useLocation();
  const siteConfirmed = location.state?.siteConfirmed === true;
  const canEnter = siteConfirmed && (isWithoutSiteMode || selectedPurchaseSite?.id);

  if (!loaded) {
    return <div className="p-6 text-gray-500">Cargando configuración…</div>;
  }

  if (!comprasPurchaseSitesEnabled) {
    return <Outlet />;
  }

  if (!canEnter) {
    return (
      <Navigate
        to="/compras/select-site"
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  return (
    <>
      <ComprasSiteBanner />
      <Outlet />
    </>
  );
};

export default ComprasPurchaseSiteGate;
